/**
 * Plain solid placeholder block — Ivory/Sand or Temple Black.
 * Captioned with the description of what photograph belongs there.
 * NEVER renders stock or generated images.
 */
export const Placeholder = ({
  caption,
  tone = "temple", // 'temple' or 'sand'
  aspect = "4 / 5",
  className = "",
  testId,
}) => {
  const isTemple = tone === "temple";
  return (
    <figure
      className={`${className}`}
      style={{ aspectRatio: aspect }}
      data-testid={testId || "placeholder-figure"}
    >
      <div
        className={`w-full h-full flex flex-col justify-between ${
          isTemple ? "bg-temple text-ivory" : "bg-sand text-temple"
        }`}
      >
        <div className="p-5 md:p-6 flex items-start justify-between">
          <span
            className="font-sans text-[0.62rem] tracking-[0.28em] uppercase"
            style={{ color: isTemple ? "#A9802F" : "#A9802F" }}
          >
            Photograph
          </span>
          <span
            className="font-sans text-[0.62rem] tracking-[0.28em] uppercase opacity-60"
          >
            Placeholder
          </span>
        </div>
        <figcaption className="p-5 md:p-6 font-sans text-[0.72rem] md:text-[0.78rem] tracking-[0.04em] leading-relaxed max-w-prose">
          {caption}
        </figcaption>
      </div>
    </figure>
  );
};

export default Placeholder;
